import React from 'react';
import PriceChange from './PriceChange';

export interface TickerItem {
  key: string;
  icon?: React.ReactNode;
  label: string;
  price: string;
  changePercent?: number;
  onClick?: () => void;
}

const PriceTicker: React.FC<{ items: TickerItem[] }> = ({ items }) => {
  if (items.length === 0) return null;
  return (
    <div className="sticky top-16 z-20 bg-canvas/85 backdrop-blur-xl border-b border-white/[0.06]">
      <div className="container-financial">
        <div className="flex items-center gap-1 overflow-x-auto scrollbar-hide py-1.5">
          {items.map((item) => (
            <div
              key={item.key}
              onClick={item.onClick}
              className="flex items-center gap-2 whitespace-nowrap px-3 py-1.5 rounded-lg cursor-pointer hover:bg-white/[0.05] transition-colors"
            >
              {item.icon && <span className="flex-shrink-0 leading-none">{item.icon}</span>}
              <span className="text-gray-500 text-xs font-medium">{item.label}</span>
              <span className="text-num text-[13px] text-gray-100 font-medium">{item.price}</span>
              {item.changePercent !== undefined && <PriceChange value={item.changePercent} showIcon={false} />}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PriceTicker;
